import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestModel } from 'src/app/typings/typing';

@Injectable({
  providedIn: 'root'
})
export class DocumentManagementService {

  source = '/eshop_backend';
  prefix = '/documents';
  filePrefix = '/file'
  bannerPrefix = '/banner'
  headers = new HttpHeaders().set('isUserCenterAdmin', 'true');


  constructor(private http: HttpClient) { }

  getFolderList(params: any) {
    return this.http.get<RequestModel>(this.prefix + '/getFolder', { params,headers:this.headers });
  }

  getTableList(params: any) {
    return this.http.get<RequestModel>(this.prefix + '/page', { params,headers:this.headers });
  }

  downloadFile(url: string) {
    return this.http.get(this.filePrefix + `/download/${url}`, { responseType: 'blob',headers:this.headers });
  }

  
}
